<template>
  <div :class="$style.container">
    <div :class="$style.backgroundImage" data-background v-lazy:background-image="content.image"></div>
    <svg :class="$style.circle" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 506 506" width="506" height="506">
      <circle cx="253" cy="253" r="250"/>
      <circle ref="circle" cx="253" cy="253" r="250" stroke="#0072ce"/>
      <circle :class="[$style.smallCircle, 'small-circle']" cx="503" cy="253" r="3" fill="#0072ce"/>
      <path class="inner-paths" d="M253 428c96.6 0 175-78.4 175-175S349.6 78 253 78 78 156.4 78 253"/>
      <path class="inner-paths" d="M353 253c0 55.2-44.8 100-100 100s-100-44.8-100-100 44.8-100 100-100"/>
    </svg>
  </div>
</template>

<script>
import gsap from 'gsap'

export default {
  props: ['content', 'settings'],

  mounted() {
    this.$nextTick(() => {
      gsap.set(this.$refs.circle, {
        strokeDashoffset: this.pathLength,
        strokeDasharray: this.pathLength,
      })

      this.$smooth.scrollbar.addListener(this.customScrollbar.bind(this));
    });
  },

  methods: {
    customScrollbar(s, dir, visible) {
      const bounds = this.$el.getBoundingClientRect()
      const elH = bounds.height
      const elTop = bounds.top + 200
      const offsetTopFromCenter = elTop - (((window.innerHeight * 1.5) - elH) / 2)
      const normalized = (offsetTopFromCenter / elH)
      const def = Math.max(Math.min(normalized, 1), 0)

      gsap.set(this.$refs.circle, {
        strokeDashoffset: this.pathLength * def,
      })

      gsap.set('.inner-paths', {
        rotationZ: i => def * 60 * (i + 2),
        transformOrigin: '50% 50%',
      })

      gsap.set('.small-circle', {
        rotationZ: - def * 360,
        svgOrigin: '253 253'
      })

      gsap.set(`[data-background]`, {
        rotationZ: def * 30,
      })
    }
  },

  computed: {
    pathLength() {
      return this.$refs.circle.getTotalLength();
    }
  }
}
</script>

<style lang="scss" module>
@import "~sass-mq/mq";

.container {
  @include grid-size();
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 0px $standard-margin-mobile;
  overflow: hidden;
  // background: rgb(31, 31, 31);

  height: 300px;

  @include mq(sm) {
    padding: 10vh $standard-margin-mobile;
    height: 500px;
  }

  @include mq(md) {
    height: auto;
  }
}

.backgroundImage {
  position: absolute;
  top: 0;
  right: 0;
  left: 0;
  height: 100%;
  width: 100%;
  margin: 0 auto;
  background-size: contain;
  background-repeat: no-repeat;
  background-position: center;
  z-index: z-index(above);

  @include mq(ds) {
    width: 80%;
  }
}

.circle {
  transform: rotate(-90deg);
  stroke-width: 2px;
  stroke: #3C3C3B;
  fill: none;
  width: 80%;

  .smallCircle {
    stroke-width: 0;
  }

  @include mq(sm) {
    width: 60%;
  }

  @include mq(ds) {
    width: auto;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/RotatingDeed.vue